<template>
  <a-modal
    class="client-modal-wrapper hospital-modal"
    :destroy-on-close="true"
    width="702px"
    :mask-closable="false"
    :visible="hospitalVisible"
    :footer="null"
    :title="title"
    @cancel="$emit('onCancel')"
  >
    <basic-form ref="basicForm" :form-data="formData">
      <template #company_id>
        <a-select
          v-decorator="[
            'company_id',
            { rules: [{ required: true, message: '请选择合作企业' }] },
          ]"
          placeholder="请选择合作企业"
        >
          <a-select-option
            v-for="item in companyData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.companyInfo.qichacha_name }}
          </a-select-option>
        </a-select>
      </template>
      <template #name>
        <a-input
          v-decorator="[
            'name',
            { rules: [{ required: true, message: '请选择医院' }] },
          ]"
          style="width: 80%"
          placeholder="请输入医院名称"
          @change="handleChange"
        />
        <a-button
          type="primary"
          style="margin-left: 10px"
          @click="seach_hospital"
        >
          搜索
        </a-button>
        <ul v-show="seach" class="select-wrapper">
          <a-spin v-if="infoLoading" style="margin: 6px" />
          <li
            v-for="(item, index) in seach_hospital_list"
            :key="index"
            class="select-item"
            @click="select_hospital(index)"
          >
            {{ item.hosName }}
          </li>
        </ul>
      </template>
      <template #provinceCity>
        <client-province-city
          v-decorator="[
            'provinceCity',
            { rules: [{ required: true, message: '请选择省市' }] },
          ]"
        />
      </template>
      <template #hospital_grade>
        <grade-input-select
          v-decorator="[
            'hospital_grade',
            { rules: [{ required: true, message: '请选择级别' }] },
          ]"
          :grade-data="hospital_grade"
        />
      </template>
      <template #hospital_level>
        <grade-input-select
          v-decorator="[
            'hospital_level',
            { rules: [{ required: true, message: '请选择等别' }] },
          ]"
          :grade-data="hospital_level"
        />
      </template>
      <template #address>
        <!-- <coordinatePickTianDiTu
          v-decorator="[
            'address',
            { rules: [{ required: true, message: '请选择医院地址' }] },
          ]"
          ref="coordinatePickRef"
          :maps="maps"
          :addrs="addrs"
          :createTime="createTime"
        /> -->

        <coordinatePickQqMap
          ref="coordinatePickRef"
          :maps="maps"
          :addrs="addrs"
          v-decorator="[
            'address',
            { rules: [{ required: true, message: '请选择医院地址' }] },
          ]"
        />
      </template>
      <template #cutOffRule>
        <cut-rule />
      </template>
      <template #incharge>
        <a-input
          v-decorator="['incharge']"
          placeholder="请输入院长名字"
          style="margin-bottom: -10px"
        />
      </template>
      <template #zip_code>
        <a-input
          v-decorator="['zip_code']"
          placeholder="请输入医院邮编"
          style="margin-bottom: -10px"
        />
      </template>
      <!-- <template #address>
				<a-textarea v-decorator="['address']" placeholder="请输入医院地址" style="margin-left:110px;" />
			</template> -->
      <template #summary>
        <a-textarea
          v-decorator="['summary']"
          rows="6"
          placeholder="请输入医院简介"
          style="resize: none; margin-left: 110px"
          maxlength="150"
        />
        <span class="textarea">限150字</span>
      </template>
      <template #unique_feature>
        <a-textarea
          v-decorator="['unique_feature']"
          rows="6"
          placeholder="请输入医院特色"
          style="resize: none; margin-left: 110px"
          maxlength="150"
        />
        <span class="textarea">限150字</span>
      </template>
      <template #hospital_class>
        <grade-input-select
          v-decorator="['hospital_class']"
          :grade-data="hospital_class"
        />
      </template>
      <template #hospital_nature>
        <grade-input-select
          v-decorator="['hospital_nature']"
          :grade-data="hospital_nature"
        />
      </template>
      <template #hospital_property_right_nature>
        <grade-input-select
          v-decorator="['hospital_property_right_nature']"
          :grade-data="hospital_property_right_nature"
        />
      </template>
      <template #hospital_profit_nature>
        <grade-input-select
          v-decorator="['hospital_profit_nature']"
          :grade-data="hospital_profit_nature"
        />
      </template>
      <!-- 药店 -->
      <template #name1>
        <a-input
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入药店名称',
                },
              ],
            },
          ]"
          placeholder="请输入药店名称"
        />
      </template>
      <template #provinceCity1>
        <client-province-city v-decorator="['provinceCity']" />
        <!-- {
              rules: [{ required: true, validator: checkProvinceCity }]
            } -->
      </template>
      <template #incharge1>
        <a-input
          v-decorator="[
            'incharge',
            {
              rules: [{ required: true, message: '请输入负责人' }],
            },
          ]"
          placeholder="请输入负责人"
          style="margin-bottom: -10px"
        />
      </template>
      <template #drugstore_kind>
        <grade-input-select
          v-decorator="[
            'drugstore_kind',
            { rules: [{ required: true, message: '请选择药店类型' }] },
          ]"
          :grade-data="drugstore_kind"
        />
      </template>

      <template #drugsCutOffRule>
        <cut-rule />
      </template>
      <template #zip_code1>
        <a-input
          v-decorator="['zip_code']"
          placeholder="请输入药店邮编"
          style="margin-bottom: -10px"
        />
      </template>
      <template #address1>
        <a-input
          v-decorator="['address']"
          placeholder="请输入药店地址"
          style="margin-left: 110px"
        />
      </template>
      <template #summary1>
        <a-textarea
          v-decorator="['summary']"
          rows="6"
          placeholder="请输入药店简介"
          style="resize: none; margin-left: 110px"
          maxlength="150"
        />
        <span class="textarea">限150字</span>
      </template>
      <template #unique_feature1>
        <a-textarea
          v-decorator="['unique_feature']"
          rows="6"
          placeholder="请输入药店特色"
          style="resize: none; margin-left: 110px"
          maxlength="150"
        />
        <span class="textarea">限150字</span>
      </template>
      <!-- 机构 -->
      <template #name2>
        <a-input
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入机构名称',
                },
              ],
            },
          ]"
          placeholder="请输入机构名称"
        />
      </template>
      <template #provinceCity2>
        <client-province-city v-decorator="['provinceCity']" />
        <!--  {
              rules: [{ required: true, validator: checkProvinceCity }]
            } -->
      </template>
      <template #incharge2>
        <a-input
          v-decorator="[
            'incharge',
            {
              rules: [{ required: true, message: '请输入负责人' }],
            },
          ]"
          placeholder="请输入负责人"
          style="margin-bottom: -10px"
        />
      </template>
      <template #institution_kind>
        <grade-input-select
          v-decorator="[
            'institution_kind',
            { rules: [{ required: true, message: '请选择机构类型' }] },
          ]"
          :grade-data="institution_kind"
        />
      </template>
      <template #orgCutOffRule>
        <cut-rule />
      </template>
      <template #zip_code2>
        <a-input
          v-decorator="['zip_code']"
          placeholder="请输入机构邮编"
          style="margin-bottom: -10px"
        />
      </template>
      <template #address2>
        <a-textarea
          v-decorator="['address']"
          placeholder="请输入机构地址"
          style="margin-left: 110px"
        />
      </template>
      <template #summary2>
        <a-textarea
          v-decorator="['summary']"
          rows="6"
          placeholder="请输入机构简介"
          style="resize: none; margin-left: 110px"
          maxlength="150"
        />
        <span class="textarea">限150字</span>
      </template>
      <template #unique_feature2>
        <a-textarea
          v-decorator="['unique_feature']"
          rows="6"
          placeholder="请输入机构特色"
          style="resize: none; margin-left: 110px"
          maxlength="150"
        />
        <span class="textarea">限150字</span>
      </template>
    </basic-form>
    <slot />
  </a-modal>
</template>

<script>
import { getSelectData, getProvinceData } from "./../utils/index";
import ClientProvinceCity from "../components/ProvinceCity";
import coordinatePickQqMap from "@/components/coordinatePickQqMap";
export default {
  components: {
    ClientProvinceCity,
    coordinatePickQqMap
  },
  props: ["hospitalVisible", "formData", "title", "type", "maps", "addrs", "createTime"],
  data() {
    return {
      infoLoading: true,
      seach: false,
      seach_hospital_list: [],
      keyword: "",
      isHospital: false,
      isDrugs: false,
      hospital_name: [], // 医院名称
      hospital_grade: {
        title: "级别",
        placeholder: "请选择级别",
        data: [],
      },

      hospital_level: {
        title: "等别",
        placeholder: "请选择等别",
        data: [],
      },
      hospital_class: {
        title: "类别",
        placeholder: "请选择类别",
        data: [],
      },
      hospital_nature: {
        title: "性质",
        placeholder: "请选择性质",
        data: [],
      },
      hospital_property_right_nature: {
        title: "产权性质",
        placeholder: "请选择产权性质",
        data: [],
      },
      hospital_profit_nature: {
        title: "盈利性质",
        placeholder: "请选择盈利性质",
        data: [],
      },
      // 药店
      drugstore_kind: {
        placeholder: "请选择类型",
        data: [],
      },
      institution_kind: {
        placeholder: "请选择类型",
        data: [],
      },
      companyData: [],
    };
  },
  mounted() {
    this.getConfig();
    this.getCompanyList();
  },
  methods: {
    // 选中的医院资料
    select_hospital(i) {
      let selhospital = this.seach_hospital_list[i];
      console.log(selhospital);
      this.seach = false;
      this.$refs.basicForm.form.setFieldsValue({
        name: selhospital.hosName,
      });
    },
    // 搜索医院
    async seach_hospital() {
      if (!this.keyword) {
        this.$message.warning("请输入关键词！");
        return;
      }
      this.infoLoading = true;
      this.seach_hospital_list = [];
      this.seach = true;
      let result = await this.$http.post("/system/get_country_hospital_list", {
        keyword: this.keyword,
      });
      if (result.data.status === 1) {
        this.infoLoading = false;
        if (result.data.data.length > 0) {
          this.seach_hospital_list = result.data.data;
        } else {
          this.seach_hospital_list = [
            {
              hosName: "暂无数据",
            },
          ];
        }
      }
    },
    // 关键字
    handleChange(e) {
      this.keyword = e.target.value;
      console.log("handleChange -> this.keyword", this.keyword);
    },
    // // 获取全国医院
    // async getConfig() {
    //   let result = await this.$http.post('/system/getConfigs');
    //   if (result.data.status === 1) {
    //     let res = result.data.data;
    //     this.hospital_name = res.list;
    //   }
    // },
    // 获取医院级别
    async getConfig() {
      let result = await this.$http.post("/system/getConfigs");
      if (result.data.status === 1) {
        let res = result.data.data;
        this.hospital_grade.data = getSelectData(res.hospital_grade);
        this.hospital_level.data = getSelectData(res.hospital_level);
        this.hospital_class.data = getSelectData(res.hospital_class);
        this.hospital_nature.data = getSelectData(res.hospital_nature);
        this.hospital_property_right_nature.data = getSelectData(
          res.hospital_property_right_nature
        );
        this.hospital_profit_nature.data = getSelectData(
          res.hospital_profit_nature
        );
        this.drugstore_kind.data = getSelectData(res.drugstore_kind);
        this.institution_kind.data = getSelectData(res.institution_kind);
      }
    },
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post("/Company/getCooperationCompanyList");
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
      }
    },
    // 自定义省市校验
    checkProvinceCity(rule, value, callback) {
      const error = [];
      if (!value || !value.province) {
        error.push("省份");
      }
      if (value.province > 4) {
        if (!value || !value.city) {
          error.push("城市");
        }
      } else {
        value.city = "";
      }
      if (error.length === 0) {
        callback();
      }
      callback(`请选择${error.join("和")}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
  .textarea {
    font-size: 12px;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
    position: relative;
    top: -37px;
    right: -550px;
  }

  .select-wrapper {
    width: 392px;
    max-height: 250px;
    min-height: 30px;
    z-index: 100;
    position: absolute;
    padding: 0;
    background: #fff;
    border-radius: 4px;
    overflow: auto;
    margin-top: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: all 0.3s;

    .select-item {
      line-height: 15px;
      list-style: none;
      padding: 7px 10px;
      margin: 0;
      cursor: pointer;

      &:hover {
        background: #e6f7ff;
      }
    }
  }
}
</style>
